"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("./client");
require("./both");
var _default = {};
exports["default"] = _default;